import styled from '@emotion/styled'
import { TextField } from '@mui/material'

export const StyledSearchInput = styled(TextField)({
  borderRadius: '15px'
})
